import { IonModal } from "@ionic/react";
import React, { useContext } from "react";
import { ModalContext } from "../../context/ModalContext";

const MobileModal = () => {
  const { title, content, component, children, clearModal, onCancel, show } =
    useContext(ModalContext);

  const handleCancel = () => {
    clearModal();
    if (typeof onCancel === "function") {
      onCancel();
    }
  };

  return (
    <IonModal
      handleBehavior="cycle"
      initialBreakpoint={0.9}
      breakpoints={[0, 0.9, 0.95]}
      onDidDismiss={handleCancel}
      isOpen={show}
    >
      <div className="p-3">
        {title && title !== "" ? <h2 className="h3 my-3 px-0">{title}</h2> : ""}
        {content}
        {component}
        {children}
      </div>
    </IonModal>
  );
};

export default MobileModal;
